// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CONST from 'app/common/lib/Const';
import i18n from 'app/common/lib/i18n';
import IndexManager from 'app/common/react/components/common/SectionList/IndexManager';
import { SearchField } from 'gestalt';

type Props = {|
  disabled?: boolean,
  hideIcon?: boolean,
  indexManager: IndexManager,
  onChange: (value: string) => void,
  value: string,
|};

export class PickerSearchField extends Component<Props> {
  componentDidMount() {
    const input = this._input;
    if (input) {
      const node = ReactDOM.findDOMNode(input);
      if (node instanceof HTMLElement) {
        const input = node.querySelector('input');
        if (input) {
          input.focus();
        }
      }
    }
  }

  _input: ?SearchField;

  handleKeyDown = (event: SyntheticKeyboardEvent<>) => {
    const { disabled, indexManager } = this.props;
    if (!disabled) {
      switch (event.which) {
        case CONST.KeyCode.ENTER:
        case CONST.KeyCode.NUMPAD_ENTER:
          event.preventDefault();
          indexManager.select();
          break;
        case CONST.KeyCode.UP:
          event.preventDefault();
          indexManager.prev();
          break;
        case CONST.KeyCode.DOWN:
          event.preventDefault();
          indexManager.next();
          break;
        default:
          break;
      }
    }
  };

  render() {
    const { onChange, value } = this.props;

    return (
      <div onKeyDown={this.handleKeyDown} style={{ width: '100%' }}>
        <SearchField
          accessibilityLabel=""
          id="pickerSearchField"
          onChange={({ value }) => onChange(value)}
          placeholder={i18n._('Search', 'search bar placeholder text')}
          ref={(searchField) => {
            this._input = searchField;
          }}
          value={value}
        />
      </div>
    );
  }
}

export default PickerSearchField;
